import { HeroFormsMobile } from 'components/hero-forms-mobile/hero-forms-mobile';
import { Layout } from '../../layout';
import { HeroForms } from '../hero-forms/hero-forms';
import { DialogForm } from "../dialog-form/dialog-form";
import { Button } from "../primitives/button/button";
import {
  Dialog,
  DialogHeader,
  DialogTrigger,
  DialogContent,
  DialogDescription,
  DialogTitle
} from "../dialog/dialog";
import React, { useState } from "react";
import { DISCOUNT_DISCLAMER } from "../../../lib/contants";

export const Hero = () => {

  const [isOpen, setOpen] = useState(false);

  const handleOpenDisclaimer = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setOpen(true);
  }

  return (
    <section className="font-open-sans">
      <Layout.Container>
        <div
          className="relative h-[calc(100vh_-_144px)] screen-600:h-[calc(110vh)] screen-1200:landscape:h-[130vh] sm:landscape:h-dvh w-full rounded-[40px] py-[43px] pl-[59px] pr-[54px] bg-cover bg-center bg-[url(../public/assets/images/webp/main.webp)] screen-700:px-5 screen-700:py-2 landscape:screen-1200:py-2 screen-1220:rounded-none">
          <div className="relative z-[1] flex justify-between h-full screen-1220:flex-col">
            <div
              className="flex flex-col justify-between screen-1220:h-full screen-1220:items-center screen-1220:mt-[72px] screen-900:mt-0 landscape:screen-1200:mt-0 screen-1220:bg-gradient-to-b from-plt-black/50 to-plt-black/0 screen-1220:rounded-[20px] screen-700:px-8 screen-500:px-4">
              <div className="screen-1220:hidden" />
              <div className="max-w-[780px] screen-700:w-full">
                <h1
                  className="uppercase text-plt-white font-bold text-[60px] leading-[70%] screen-1220:text-center screen-1220:mt-6 landscape:screen-1200:landscape:text-4xl screen-950:landscape:text-3xl screen-700:text-2xl screen-700:mx-auto  screen-350:text-xl">
                  ЖК «Крекшино Парк»
                  <span className='text-[40px] screen-700:text-2xl screen-350:text-xl'> Старт продажи новой очереди!</span>
                  <br />
                  <span className='text-[40px] screen-700:text-2xl mt-20 screen-700:mt-10 inline-block screen-350:text-xl screen-350:mt-3'>квартиры от 6,2 млн руб</span>
                </h1>
                <DialogForm title={'УЗНАЙТЕ ПОДРОБНЕЕ О СКИДКЕ'} subtitle={'Скидки до 30%'}
                  celtype={'getDiscountInfo'} disclaimerTitle={'Подробнее об условиях скидки'}
                  actionBtnText={'Оставить заявку'}
                  disclaimer={DISCOUNT_DISCLAMER}>
                  <div
                    className='cursor-pointer flex flex-col justify-center items-center px-20 pt-2 pb-3 bg-white rounded-[20px] mt-8 w-fit screen-500:px-10 screen-500:w-full screen-900:mx-auto screen-900:mt-4'>
                    <span className='text-5xl text-plt-secondary font-bold uppercase text-center screen-500:text-xl'>Скидки до 30%</span>
                    <Dialog open={isOpen} onOpenChange={() => setOpen(!isOpen)}>
                      <DialogTrigger asChild onClick={(e) => handleOpenDisclaimer(e)}>
                        <Button className='text-plt-secondary text-xs uppercase py-0 leading-none h-5 mt-2' variant='ghost'>
                          Подробнее об условиях скидки
                        </Button>
                      </DialogTrigger>
                      <DialogContent>
                        <DialogHeader>
                          <DialogTitle className='font-bold text-xl font-open-sans'>
                            Условия скидки
                          </DialogTitle>
                          <DialogDescription className='sr-only'>
                            Условия скидки
                          </DialogDescription>
                        </DialogHeader>
                        <div>
                          {DISCOUNT_DISCLAMER}
                        </div>
                      </DialogContent>
                    </Dialog>
                  </div>
                </DialogForm>
                <HeroFormsMobile />
              </div>
              <div
                className="max-w-[598px] bg-plt-secondary px-7 py-5 rounded-[21px] screen-700:rounded-[5px] screen-500:py-3 screen-950:landscape:py-2 screen-350:hidden">
                <p className="text-plt-white font-semibold screen-1220:text-center screen-500:text-[10px] ">
                  Рядом лес, водоём и парк. Закрытая территория,
                  видеонаблюдение. 9 минут на автобусе до станции «Санино»
                  (МЦД-4), 20 минут от МКАД на автомобиле
                </p>
              </div>
            </div>
            <HeroForms className="screen-1220:hidden" />
          </div>
          <div
            className="absolute top-0 left-0 right-0 bottom-0 w-full h-full rounded-[40px] bg-gradient-to-r from-plt-black/80 to-plt-black/0 screen-1220:hidden" />
        </div>
      </Layout.Container>
    </section>
  );
};
